import { render, staticRenderFns } from "./MarkComplete.vue?vue&type=template&id=ddc6735c&scoped=true&"
import script from "./MarkComplete.vue?vue&type=script&lang=js&"
export * from "./MarkComplete.vue?vue&type=script&lang=js&"
import style0 from "./MarkComplete.vue?vue&type=style&index=0&id=ddc6735c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc6735c",
  null
  
)

export default component.exports